import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';
import { NewsletterSignup } from './NewsletterSignup';

export const WelcomeModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Check if user has already signed up in this session
    const hasSignedUp = sessionStorage.getItem('newsletterSignedUp');
    const hasSeenModal = sessionStorage.getItem('welcomeModalSeen');
    
    // Show modal if user hasn't signed up and hasn't seen it yet
    if (!hasSignedUp && !hasSeenModal) {
      // Delay showing modal by 2 seconds to let page load
      const timer = setTimeout(() => {
        setIsOpen(true);
        sessionStorage.setItem('welcomeModalSeen', 'true');
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleSignupSuccess = () => {
    // Close modal after successful signup
    setTimeout(() => {
      setIsOpen(false);
    }, 2000); // Give user time to see success message
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogTitle className="sr-only">Newsletter Signup</DialogTitle>
        <DialogDescription className="sr-only">
          Sign up for our newsletter to receive wellness tips and updates
        </DialogDescription>
        <NewsletterSignup 
          variant="modal" 
          onSuccess={handleSignupSuccess}
        />
      </DialogContent>
    </Dialog>
  );
}; 